import _ from 'lodash';
import PubSub from '../utils/PubSub';

export function initVisibilityChangeEvents(callback = sendVisibilityChangeEvent) {
  window.addEventListener('load', callback);
  document.addEventListener('DOMContentLoaded', callback);
  window.addEventListener('resize', _.debounce(callback, 150));
  window.addEventListener('scroll', _.debounce(callback, 150));
}

export function sendVisibilityChangeEvent() {
  PubSub.publish('visibilityChange');
}

export function subscribeToVisibilityChangeEvent(callback) {
  return PubSub.subscribe('visibilityChange', callback);
}